import React, { useState } from "react";
import PlansSectionHeader from "./PlansSectionHeader";
import Spinner from "../common/Spinner/Spinner";
import ScriptTag from "react-script-tag";
import getEnvEndpoints from "../../utils/endpoints";
import PlanCard from "./PlanCard";
import Modal from "../common/Modal";
import LogService from "../../utils/logs";
import { useHistory } from "react-router";
import useIsMounted from "../../hooks/useIsMounted";

const endpoints = getEnvEndpoints();

const PlansSectionUserPaid = ({ plans, onSubscribe }) => {
  const [paypalLoaded, setPaypalLoaded] = useState(false);
  const [showSubscriptionLoading, setShowSubscriptionLoading] = useState(false);
  const history = useHistory();

  const monthPlan = plans.find((i) => i.frequency === "MONTH");
  const yearPlan = plans.find((i) => i.frequency === "YEAR");
  const isMounted = useIsMounted()

  const startSubscription = () => {
    setShowSubscriptionLoading(true);
  };

  const finishSubscription = async (plan) => {
    await onSubscribe(plan);
    LogService.logPurchase();
    isMounted.current && setShowSubscriptionLoading(false);
    history.push("/home");
  };

  return (
    <>
      {!paypalLoaded && (
        <ScriptTag
          onLoad={() => isMounted.current && setPaypalLoaded(true)}
          type="text/javascript"
          src={`https://www.paypal.com/sdk/js?client-id=${endpoints.paypalClientId}&vault=true&disable-funding=card,credit,bancontact`}
        />
      )}

      {showSubscriptionLoading && (
        <Modal onClose={() => setShowSubscriptionLoading(false)} onClickOutside={false} loading={showSubscriptionLoading}>
          <div className="text-center text-2xl font-bold">Subscribing...</div>
          <div className="text-center mt-5">
            That can take several moments...
          </div>
          <div className="flex justify-center my-5">
            <Spinner />
          </div>
        </Modal>
      )}

      <PlansSectionHeader
        title={`PMIstandards+ Plan`}
        description={
          <div>
            <div className="mt-3">
              Join PMI now and take advantage of an exclusive
              opportunity to enjoy this offering at no additional cost as part
              of your membership benefits.
            </div>
          </div>
        }
      />

      <div className="container md:w-3/4 flex flex-col mx-auto">
        {!paypalLoaded && (
          <div className="flex flex-col justify-center items-center">
            <Spinner />
            <p className="mt-3">Loading subscription plans...</p>
          </div>
        )}

        {paypalLoaded && (
          <div
            className={`flex flex-col lg:flex-row items-center items-stretch justify-center mt-24`}
          >
            <PlanCard
              header="Monthly Subscription"
              price={parseInt(monthPlan.price, 10)}
              tagline={
                <span>
                  Billed Monthly
                  <br />
                  <span className="text-sm mt-2">Cancel at Anytime</span>
                </span>
              }
              paypayId="monthly-button"
              color="border-orange-brand-500"
              planId={monthPlan.id}
              paypalLoaded={paypalLoaded}
              onStart={startSubscription}
              onEnd={finishSubscription}
            />

          </div>
        )}
      </div>
    </>
  );
};

export default PlansSectionUserPaid;
